import React from 'react';

export const FreeTierCard = ({ onGetStarted }) => {
  return (
    <div className="mt-12 sm:mt-16 max-w-4xl mx-auto px-4 sm:px-0">
      <div
        className="relative overflow-hidden rounded-2xl backdrop-blur-sm border-2 border-border p-6 sm:p-8 group transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
        style={{
          background: 'linear-gradient(135deg, var(--color-primary), var(--color-secondary))',
          boxShadow: '0 8px 32px var(--color-primary)30',
        }}
      >
        {/* Enhanced glassmorphic overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-300" />

        {/* Animated background bubbles - adjusted for mobile */}
        <div className="absolute inset-0 opacity-30">
          <div
            className="absolute rounded-full top-0 right-0 translate-x-6 sm:translate-x-12 -translate-y-6 sm:-translate-y-10 group-hover:scale-110 transition-transform duration-700"
            style={{
              background: 'linear-gradient(135deg, var(--color-primary), var(--color-secondary))',
              width: '80px',
              height: '80px',
              filter: 'brightness(1.2) saturate(1.3)',
            }}
          />
          <div
            className="absolute rounded-full bottom-0 left-0 -translate-x-4 sm:-translate-x-8 translate-y-4 sm:translate-y-8 group-hover:scale-110 transition-transform duration-700"
            style={{
              background: 'linear-gradient(45deg, var(--color-primary), var(--color-secondary))',
              width: '60px',
              height: '60px',
              filter: 'brightness(1.3) saturate(1.4)',
            }}
          />
        </div>

        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
          <div className="text-center md:text-left text-white">
            <h3 className="text-xl sm:text-2xl font-bold mb-2 drop-shadow-sm">START FOR FREE</h3>
            <p className="text-base sm:text-lg opacity-90 leading-relaxed font-medium drop-shadow-sm">
              Get started with full N5 content: Access 800+ words and 300+ sentences, absolutely free. No credit card required.
            </p>
          </div>
          <div className="flex-shrink-0 w-full md:w-auto">
            <button
              onClick={onGetStarted}
              className="w-full px-6 sm:px-8 py-3 border-2 border-white/40 text-base sm:text-lg font-semibold rounded-xl text-white bg-white/20 backdrop-blur-sm hover:bg-white hover:text-primary transition-all duration-300 hover:scale-105 active:scale-95 drop-shadow-lg"
            >
              Get Started Free
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
